/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import CategoryStatisticsDto from '../model/CategoryStatisticsDto';
import CreateGameSessionRequestDto from '../model/CreateGameSessionRequestDto';
import ErrorDto from '../model/ErrorDto';
import GameSessionDto from '../model/GameSessionDto';
import GameSessionProgressDto from '../model/GameSessionProgressDto';
import GameSessionStatisticsDto from '../model/GameSessionStatisticsDto';
import SubmitAnswerRequestDto from '../model/SubmitAnswerRequestDto';
import UserStatisticsDto from '../model/UserStatisticsDto';

/**
* GameSession service.
* @module api/GameSessionApi
* @version v0
*/
export default class GameSessionApi {

    /**
    * Constructs a new GameSessionApi. 
    * @alias module:api/GameSessionApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the closeGameSession operation.
     * @callback module:api/GameSessionApi~closeGameSessionCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Close/end a game session by ID
     * @param {Number} id ID of the game session to close
     * @param {module:api/GameSessionApi~closeGameSessionCallback} callback The callback function, accepting three arguments: error, data, response
     */
    closeGameSession(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling closeGameSession");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/api/private/game-session/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createGameSession operation.
     * @callback module:api/GameSessionApi~createGameSessionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/GameSessionDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create a new game session for the authenticated user
     * @param {module:model/CreateGameSessionRequestDto} createGameSessionRequestDto 
     * @param {module:api/GameSessionApi~createGameSessionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/GameSessionDto}
     */
    createGameSession(createGameSessionRequestDto, callback) {
      let postBody = createGameSessionRequestDto;
      // verify the required parameter 'createGameSessionRequestDto' is set
      if (createGameSessionRequestDto === undefined || createGameSessionRequestDto === null) {
        throw new Error("Missing the required parameter 'createGameSessionRequestDto' when calling createGameSession");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = GameSessionDto;
      return this.apiClient.callApi(
        '/api/private/game-session', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getActiveGameSession operation.
     * @callback module:api/GameSessionApi~getActiveGameSessionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/GameSessionDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get or create an active session for the authenticated user by session type
     * Returns an existing active session if found, otherwise creates a new one. Always returns a session (never 404).
     * @param {String} sessionType Type of the session to retrieve or create
     * @param {module:api/GameSessionApi~getActiveGameSessionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/GameSessionDto}
     */
    getActiveGameSession(sessionType, callback) {
      let postBody = null;
      // verify the required parameter 'sessionType' is set
      if (sessionType === undefined || sessionType === null) {
        throw new Error("Missing the required parameter 'sessionType' when calling getActiveGameSession");
      }

      let pathParams = {
      };
      let queryParams = {
        'sessionType': sessionType
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = GameSessionDto;
      return this.apiClient.callApi(
        '/api/private/game-session/active', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCategoryStatistics operation.
     * @callback module:api/GameSessionApi~getCategoryStatisticsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CategoryStatisticsDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get statistics for a specific session type/category
     * @param {String} sessionType Type of the session to retrieve statistics for
     * @param {module:api/GameSessionApi~getCategoryStatisticsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CategoryStatisticsDto}
     */
    getCategoryStatistics(sessionType, callback) {
      let postBody = null;
      // verify the required parameter 'sessionType' is set
      if (sessionType === undefined || sessionType === null) {
        throw new Error("Missing the required parameter 'sessionType' when calling getCategoryStatistics");
      }

      let pathParams = {
      };
      let queryParams = {
        'sessionType': sessionType
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = CategoryStatisticsDto;
      return this.apiClient.callApi(
        '/api/private/game-session/statistics/category', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getGameSessionById operation.
     * @callback module:api/GameSessionApi~getGameSessionByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/GameSessionDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get a game session by ID
     * @param {Number} id ID of the game session
     * @param {module:api/GameSessionApi~getGameSessionByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/GameSessionDto}
     */
    getGameSessionById(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getGameSessionById");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = GameSessionDto;
      return this.apiClient.callApi(
        '/api/private/game-session/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getGameSessionProgress operation.
     * @callback module:api/GameSessionApi~getGameSessionProgressCallback
     * @param {String} error Error message, if any.
     * @param {module:model/GameSessionProgressDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get progress details for a game session
     * @param {Number} id ID of the game session
     * @param {module:api/GameSessionApi~getGameSessionProgressCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/GameSessionProgressDto}
     */
    getGameSessionProgress(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getGameSessionProgress");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = GameSessionProgressDto;
      return this.apiClient.callApi(
        '/api/private/game-session/{id}/progress', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getGameSessionStatistics operation.
     * @callback module:api/GameSessionApi~getGameSessionStatisticsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/GameSessionStatisticsDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get statistics for a game session
     * @param {Number} id ID of the game session
     * @param {module:api/GameSessionApi~getGameSessionStatisticsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/GameSessionStatisticsDto}
     */
    getGameSessionStatistics(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getGameSessionStatistics");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = GameSessionStatisticsDto;
      return this.apiClient.callApi(
        '/api/private/game-session/{id}/statistics', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getUserGameSessions operation.
     * @callback module:api/GameSessionApi~getUserGameSessionsCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/GameSessionDto>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get all game sessions for the authenticated user
     * @param {module:api/GameSessionApi~getUserGameSessionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/GameSessionDto>}
     */
    getUserGameSessions(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [GameSessionDto];
      return this.apiClient.callApi(
        '/api/private/game-session', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getUserStatistics operation.
     * @callback module:api/GameSessionApi~getUserStatisticsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserStatisticsDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get overall statistics for the authenticated user across all sessions
     * @param {module:api/GameSessionApi~getUserStatisticsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserStatisticsDto}
     */
    getUserStatistics(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = UserStatisticsDto;
      return this.apiClient.callApi(
        '/api/private/game-session/statistics/user', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getUserStatisticsById operation.
     * @callback module:api/GameSessionApi~getUserStatisticsByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserStatisticsDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get overall statistics for a specific user by user ID across all sessions
     * @param {Number} userId ID of the user to retrieve statistics for
     * @param {module:api/GameSessionApi~getUserStatisticsByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserStatisticsDto}
     */
    getUserStatisticsById(userId, callback) {
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling getUserStatisticsById");
      }

      let pathParams = {
        'userId': userId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = UserStatisticsDto;
      return this.apiClient.callApi(
        '/api/private/game-session/statistics/user/{userId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the markPageAsCompleted operation.
     * @callback module:api/GameSessionApi~markPageAsCompletedCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Mark a page as completed in a game session
     * @param {Number} sessionId ID of the game session
     * @param {Number} pageId ID of the page to mark as completed
     * @param {module:api/GameSessionApi~markPageAsCompletedCallback} callback The callback function, accepting three arguments: error, data, response
     */
    markPageAsCompleted(sessionId, pageId, callback) {
      let postBody = null;
      // verify the required parameter 'sessionId' is set
      if (sessionId === undefined || sessionId === null) {
        throw new Error("Missing the required parameter 'sessionId' when calling markPageAsCompleted");
      }
      // verify the required parameter 'pageId' is set
      if (pageId === undefined || pageId === null) {
        throw new Error("Missing the required parameter 'pageId' when calling markPageAsCompleted");
      }

      let pathParams = {
        'sessionId': sessionId,
        'pageId': pageId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/api/private/game-session/{sessionId}/page/{pageId}/complete', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the submitAnswer operation.
     * @callback module:api/GameSessionApi~submitAnswerCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Submit an answer to a question
     * @param {module:model/SubmitAnswerRequestDto} submitAnswerRequestDto 
     * @param {module:api/GameSessionApi~submitAnswerCallback} callback The callback function, accepting three arguments: error, data, response
     */
    submitAnswer(submitAnswerRequestDto, callback) {
      let postBody = submitAnswerRequestDto;
      // verify the required parameter 'submitAnswerRequestDto' is set
      if (submitAnswerRequestDto === undefined || submitAnswerRequestDto === null) {
        throw new Error("Missing the required parameter 'submitAnswerRequestDto' when calling submitAnswer");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/api/private/game-session/answer', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
